import { NgModule } from 'ng-metadata/core';
import { BannerComponent } from './banner.component';
import { BannerService } from './banner.service';
import * as angular from 'angular';
import './banner.scss';

angular.module('mwAppComponents.banner.services', [])
    .service('mwBannerService', BannerService);


/**
 * @ngdoc module
 * @name mw.components.banner
 * @description
 *
 * Banner
 */
@NgModule({
    declarations: [BannerComponent],
    providers: [{provide: 'mwBannerService', useClass: BannerService}],
    imports: ['mwAppComponents.banner.services']
})
export class BannerModule {}



// WEBPACK FOOTER //
// ./src/lib/components/banner/banner.module.ts